export const validateTextInput = (inputValue, inputName, required, maxLength = null) => {
    if (required && inputValue === '') {
        return inputName + " is required.";
    } else if (maxLength && inputValue.length > maxLength) {
        return inputName + " cannot be longer than " + maxLength + " characters."
    }

    return null;
}